// extracted by mini-css-extract-plugin
export default {"param-wrapper":"B9uc7","chip":"DfFKP"};